export default "__VITE_ASSET__oBlPN4Sx__"